var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReglageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.25C9.6736 11.25 10.625 10.2426 10.625 9C10.625 7.75736 9.6736 6.75 8.5 6.75C7.32639 6.75 6.375 7.75736 6.375 9C6.375 10.2426 7.32639 11.25 8.5 11.25Z",
    stroke: "#B3B9C4",
    strokeWidth: 1.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41797 9.66007V8.34007C1.41797 7.56007 2.02005 6.91507 2.7638 6.91507C4.04589 6.91507 4.57005 5.95507 3.92547 4.77757C3.55714 4.10257 3.77672 3.22507 4.4213 2.83507L5.64672 2.09257C6.2063 1.74007 6.9288 1.95007 7.26172 2.54257L7.33963 2.68507C7.97713 3.86257 9.02547 3.86257 9.67005 2.68507L9.74797 2.54257C10.0809 1.95007 10.8034 1.74007 11.363 2.09257L12.5884 2.83507C13.233 3.22507 13.4526 4.10257 13.0842 4.77757C12.4396 5.95507 12.9638 6.91507 14.2459 6.91507C14.9826 6.91507 15.5917 7.55257 15.5917 8.34007V9.66007C15.5917 10.4401 14.9896 11.0851 14.2459 11.0851C12.9638 11.0851 12.4396 12.0451 13.0842 13.2226C13.4526 13.9051 13.233 14.7751 12.5884 15.1651L11.363 15.9076C10.8034 16.2601 10.0809 16.0501 9.74797 15.4576L9.67005 15.3151C9.03255 14.1376 7.98422 14.1376 7.33963 15.3151L7.26172 15.4576C6.9288 16.0501 6.2063 16.2601 5.64672 15.9076L4.4213 15.1651C3.77672 14.7751 3.55714 13.8976 3.92547 13.2226C4.57005 12.0451 4.04589 11.0851 2.7638 11.0851C2.02005 11.0851 1.41797 10.4401 1.41797 9.66007Z",
    stroke: "#B3B9C4",
    strokeWidth: 1.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReglageIcon);
export default __webpack_public_path__ + "static/media/reglageIcon.81b19f2b94628e7e8a5837448439d3f7.svg";
export { ForwardRef as ReactComponent };